import type { PropsWithChildren } from "react"

const colorClasses: Record<string, string> = {
  red: "bg-red-500 text-white",
  blue: "bg-blue-500 text-white",
  orange: "bg-orange-500 text-white",
  green: "bg-green-500 text-white",
  slate: "bg-slate-100 text-slate-600",
}

export function Badge({
  color = "red",
  children,
}: PropsWithChildren<{ color?: keyof typeof colorClasses }>) {
  return (
    <span className={`text-[10px] px-1.5 py-0.5 rounded-full font-bold ${colorClasses[color]}`}>
      {children}
    </span>
  )
}
